// Library data source (source-agnostic loader).
//
// The site reads its expression data SYNCHRONOUSLY from a build-time-generated
// file — `expressions.generated.json`, produced by `scripts/sync-expressions.mjs`
// from the live Airtable "Published — Website" set. No runtime Airtable call,
// no token in the browser, no network dependency at page load.
//
// Until the first real sync has populated the generated file, we fall back to
// the hand-curated stubs in `libraryFixtures.fallback.js` so the app renders in
// dev. The named export name (`LIBRARY_FIXTURES`) is kept stable so every
// consumer (LibraryPage, SavedScope, AddToCollectionPicker, savedStore) is
// unchanged by the swap.
import generated from './expressions.generated.json';
import { FALLBACK_EXPRESSIONS } from './libraryFixtures.fallback';
import { bumpMirrorTick } from './mirrorCache';

const synced = Array.isArray(generated && generated.expressions)
  ? generated.expressions
  : [];

/** All published expressions the library renders. uid-keyed, fit values are
 *  byte-exact Korean strings. Sourced from the synced file when present,
 *  otherwise the committed fallback seed. */
// On the empty-sync fallback path, COPY the seed (not alias it): hydrateLibraryFixtures
// mutates LIBRARY_FIXTURES in place, and we must never overwrite the shared
// FALLBACK_EXPRESSIONS export that other modules import.
export const LIBRARY_FIXTURES = synced.length ? synced : [...FALLBACK_EXPRESSIONS];

/** True when serving live synced data (vs. the fallback seed). */
export const IS_SYNCED_DATA = synced.length > 0;

/**
 * Replace the published expression set IN PLACE with live data fetched at runtime
 * (the Firestore mirror written by the Airtable sync), so a data refresh goes
 * live without a redeploy. Mutates the existing array so every consumer's
 * reference stays valid; no-op for an empty/invalid payload (keeps the baked
 * data). See docs/airtable-runtime-mirror-design.md.
 * @returns {boolean} true if hydrated, false if the payload was empty/invalid.
 */
export function hydrateLibraryFixtures(next) {
  if (!Array.isArray(next) || !next.length) return false;
  LIBRARY_FIXTURES.length = 0;
  for (const item of next) LIBRARY_FIXTURES.push(item);
  // Post-mount reconciliation support: this array is not reactive, so mounted
  // consumers (the keep-alive'd home) subscribe to the tick instead.
  bumpMirrorTick();
  return true;
}
